import React, { useContext } from "react";
import { WplywContext } from "../../../../../../../context/wplywContext";
import { useAuth } from "../../../../../../../context/AuthContext";
import Label from "../../../../../../../components/Label";
import FixedNumberInput from "../../../../../../../components/FixedNumberInput";
import numberFormat from "../../../../../../../components/numberFormat";
import TextArea from "antd/es/input/TextArea";
import formatPrice from "../../../../../../../components/formatPrice";
import CommentWithFragments from "../../../../../../../components/CommentWithFragments";

const InitReserve = ({ selectedPerson, total }) => {
	const { wplyw, setWplyw } = useContext(WplywContext);
	const { user } = useAuth();
	const isDisabled =
		wplyw.mode === "preview" ||
		selectedPerson.msr_reserves_generated_file ||
		Boolean(selectedPerson?.msr_persons_transfers_generated_file);
	const handleValueChange = (field, value) => {
		if (value === null || value === undefined) return;

		setWplyw((prevData) => {
			const updatedPersons =
				prevData.wplyw_data.data.msr_wplywy.msr_persons.map((person) =>
					person.msr_persons_id === selectedPerson.msr_persons_id
						? {
								...person,
								[field]: value,
								msr_reserves_changed: true,
								msr_reserves_user: user.user.mlg_users_id,
						  }
						: person
				);

			const changes = [...(prevData.changes || [])];

			if (field === "msr_reserves_amount") {
				// Remove old change log for msr_reserves_amount if it exists
				const filteredChanges = changes.filter(
					(change) =>
						!(
							change.field === "msr_reserves_amount" &&
							change.personid ===
								selectedPerson.msr_persons_own_id
						)
				);

				// Add new change log for msr_reserves_amount
				filteredChanges.push({
					etap: "Rezerwa",
					field: "msr_reserves_amount",
					label: "Kwota rezerwy",
					action: "edit",
					oldValue: selectedPerson.msr_reserves_amount || 0,
					newValue: value,
					datetime: Math.floor(Date.now() / 1000),
					user: user?.user?.mlg_users_id || null,
					objectid: null,
					wplywid:
						prevData.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
					personid: selectedPerson.msr_persons_own_id,
				});

				return {
					...prevData,
					wplyw_data: {
						...prevData.wplyw_data,
						data: {
							...prevData.wplyw_data.data,
							msr_wplywy: {
								...prevData.wplyw_data.data.msr_wplywy,
								msr_persons: updatedPersons,
							},
						},
					},
					changes: filteredChanges,
				};
			}

			if (field === "msr_reserves_comment") {
				// Remove old change log for msr_reserves_comment if it exists
				const filteredChanges = changes.filter(
					(change) =>
						!(
							change.field === "msr_reserves_comment" &&
							change.personid ===
								selectedPerson.msr_persons_own_id
						)
				);

				// Add new change log for msr_reserves_comment
				filteredChanges.push({
					etap: "Rezerwa",
					field: "msr_reserves_comment",
					label: "Uwagi do rezerwy",
					action: "edit",
					oldValue: selectedPerson.msr_reserves_comment || "",
					newValue: value,
					datetime: Math.floor(Date.now() / 1000),
					user: user?.user?.mlg_users_id || null,
					objectid: null,
					wplywid:
						prevData.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
					personid: selectedPerson.msr_persons_own_id,
				});

				return {
					...prevData,
					wplyw_data: {
						...prevData.wplyw_data,
						data: {
							...prevData.wplyw_data.data,
							msr_wplywy: {
								...prevData.wplyw_data.data.msr_wplywy,
								msr_persons: updatedPersons,
							},
						},
					},
					changes: filteredChanges,
				};
			}
			return {
				...prevData,
				wplyw_data: {
					...prevData.wplyw_data,
					data: {
						...prevData.wplyw_data.data,
						msr_wplywy: {
							...prevData.wplyw_data.data.msr_wplywy,
							msr_persons: updatedPersons,
						},
					},
				},
			};
		});
	};

	const availableReserve = parseFloat(
		total -
			selectedPerson.msr_transfers.reduce(
				(sum, tr) => sum + parseFloat(tr.msr_transfers_amount || 0),
				0
			)
	).toFixed(2);

	return (
		<div style={{ marginTop: "16px" }}>
			<div
				style={{
					border: "1px solid #BD8136",
					borderRadius: "10px",
					overflow: "hidden",
					background: "#F9F9F9",
				}}
			>
				<div style={{ padding: "20px", display: "grid", gap: "24px" }}>
					<div
						style={{
							display: "flex",
							gap: "20px",
							alignItems: "center",
						}}
					>
						<div
							style={{
								background: "white",
								color: "black",
								padding: "7px 15px",
								fontSize: "16px",
								borderRadius: "5px",
							}}
						>
							#0 Kwota rezerwy
						</div>
					</div>

					<div
						style={{
							padding: "16px",
							borderRadius: "8px",
							background: "white",
							display: "grid",
							gridTemplateColumns: "repeat(3, 1fr)",
							gap: "20px",
						}}
					>
						<div>
							<Label required>
								Kwota przeznaczona na rezerwę
							</Label>
							<FixedNumberInput
								mode={wplyw.mode}
								disabled={isDisabled}
								value={selectedPerson.msr_reserves_amount || 0}
								calculator={true}
								maxvalue={availableReserve}
								addonAfter="zł"
								aria-label="Kwota rezerwy"
								onChange={(value) =>
									handleValueChange(
										"msr_reserves_amount",
										value
									)
								}
							/>
						</div>
						<div>
							<div>Procent całości</div>
							<div
								style={{
									fontSize: "16px",
									marginTop: "8px",
									fontWeight: "700",
								}}
							>
								{formatPrice(
									((selectedPerson.msr_reserves_amount || 0) /
										total) *
										100
								)}
								%
							</div>
						</div>
						{selectedPerson.msr_reserves_userDetails && (
							<div>
								<div>Ostatnia zmiana wykonana przez</div>
								<div
									style={{
										fontSize: "16px",
										marginTop: "8px",
										fontWeight: "700",
									}}
								>
									{
										selectedPerson.msr_reserves_userDetails
											.mlg_users_fullname
									}
								</div>
							</div>
						)}
					</div>
					<div>
						<Label>Uwagi do rezerwy</Label>
						<CommentWithFragments
							disabled={isDisabled}
							commentName={"msr_reserves_comment"}
							defaultValue={
								selectedPerson.msr_reserves_comment || ""
							}
							value={selectedPerson.msr_reserves_comment || ""}
							placeholder="Dodaj uwagi do etapu rezerwy"
							onChange={(e) =>
								handleValueChange(
									"msr_reserves_comment",
									e.target.value
								)
							}
						/>
					</div>
				</div>
				{selectedPerson.msr_reserves_generated_file ? (
					<>
						<div
							style={{
								background: "rgb(82, 196, 26)",
								color: "white",
								padding: "10px 20px",
								textAlign: "center",
								marginTop: "20px",
							}}
						>
							Przelew wygenerowany - nie można edytować
						</div>
					</>
				) : (
					<></>
				)}
			</div>
		</div>
	);
};

export default InitReserve;
